import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRight, Mail, MapPin, Phone } from 'lucide-react';
import { company, navLinks } from '../data/site';
export function Header() {
  const [solid, setSolid] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 80);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  const onNavClick = () => setOpen(false);
  return <header className="fixed inset-x-0 top-0 z-50" data-id="element-213" data-mp="36d4nwwg8baud">
      <div className="hidden border-b border-white/10 bg-navy-900 lg:block" data-id="element-214" data-mp="3baxu3phj84un">
        <div className="mx-auto flex max-w-[1400px] items-center justify-between px-8 py-2.5 text-[12px] text-white/55" data-id="element-215" data-mp="3fbgn3mv5vgyf">
          <span className="flex items-center gap-2" data-id="element-216" data-mp="2wl4dkkvppwdk">
            <MapPin className="h-3.5 w-3.5 text-brand-400" aria-hidden="true" data-id="element-217" data-mp="2wihx1vqug6j7" />
            Serving {company.region}
          </span>
          <div className="flex items-center gap-7" data-id="element-218" data-mp="2mm55p4iru4rm">
            <a href={`mailto:${company.email}`} className="flex items-center gap-2 transition hover:text-white" data-id="element-219" data-mp="2mmwyk7kzhoe7">
              <Mail className="h-3.5 w-3.5 text-brand-400" aria-hidden="true" data-id="element-220" data-mp="2hpyaa5o04bnx" />
              {company.email}
            </a>
            <span className="text-white/30" data-id="element-221" data-mp="3abponnexd20w">{company.hours}</span>
          </div>
        </div>
      </div>

      <div className={['border-b transition-all duration-500', solid ? 'border-mist-200 bg-white shadow-[0_10px_30px_-20px_rgba(10,26,47,0.5)]' : 'border-white/10 bg-navy-900/20 backdrop-blur-[2px]'].join(' ')} data-id="element-222" data-mp="35l0v82jopuz4">
        <div className="mx-auto flex max-w-[1400px] items-center justify-between gap-6 px-5 py-3 sm:px-8" data-id="element-223" data-mp="3tbdeg9kdre50">
          <a href="#home" aria-label={`${company.name} — home`} className={['flex shrink-0 items-center transition-all duration-500', solid ? '' : 'rounded-sm bg-white px-3 py-2'].join(' ')} data-id="element-224" data-mp="1rd1j2sm1afhs">
            <img src={company.logo} alt={`${company.name} logo`} className="h-9 w-auto sm:h-11" data-id="element-225" data-mp="1mmuw0x76731n" />
          </a>

          <nav className="hidden items-center gap-8 xl:flex" aria-label="Main navigation" data-id="element-226" data-mp="18nboo6m6nvqe">
            {navLinks.map(l => <a key={l.href} href={l.href} className={['group relative py-1 text-[13px] font-semibold uppercase tracking-[0.12em] transition', solid ? 'text-navy hover:text-brand-600' : 'text-white/80 hover:text-white'].join(' ')} data-id="element-227" data-mp="1cpq5yma7enfk">
                {l.label}
                <span className="absolute -bottom-0.5 left-0 h-[2px] w-0 bg-brand-500 transition-all duration-300 group-hover:w-full" data-id="element-228" data-mp="2y2jk5rw5u841" />
              </a>)}
          </nav>

          <div className="flex items-center gap-3" data-id="element-229" data-mp="hftp28vp214h">
            <a href={company.phoneHref} className={['hidden items-center gap-2 text-sm font-bold tracking-tight md:flex', solid ? 'text-navy' : 'text-white'].join(' ')} data-id="element-230" data-mp="hh4u0c0vlex6">
              <Phone className="h-4 w-4 text-brand-500" aria-hidden="true" data-id="element-231" data-mp="154mmk9rysh17" />
              {company.phone}
            </a>

            <a href="#contact" className="group hidden items-center gap-2 bg-brand-500 px-5 py-3.5 text-[12px] font-bold uppercase tracking-[0.14em] text-white transition hover:bg-brand-600 sm:inline-flex" data-id="element-232" data-mp="1059qqzj47zmh">
              Get a Free Estimate
              <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-233" data-mp="3gtx4eq6cczak" />
            </a>

            <button type="button" onClick={() => setOpen(v => !v)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} className={['relative inline-flex h-11 w-11 flex-col items-center justify-center gap-[5px] xl:hidden', solid || open ? 'text-navy' : 'text-white'].join(' ')} data-id="element-234" data-mp="3bxotxq339u9q">
              <motion.span animate={open ? {
              rotate: 45,
              y: 7
            } : {
              rotate: 0,
              y: 0
            }} className="block h-[2px] w-6 bg-current" data-id="element-235" data-mp="1k8fohlohr16j" />
              <motion.span animate={open ? {
              opacity: 0
            } : {
              opacity: 1
            }} className="block h-[2px] w-6 bg-current" data-id="element-236" data-mp="1p560nxx6dcmo" />
              <motion.span animate={open ? {
              rotate: -45,
              y: -7
            } : {
              rotate: 0,
              y: 0
            }} className="block h-[2px] w-6 bg-current" data-id="element-237" data-mp="1xzkjubktt7b2" />
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence data-id="element-238" data-mp="15i8779a7zo7f">
        {open && <motion.nav key="mobile-nav" initial={{
        opacity: 0,
        y: -12
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -12
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} aria-label="Mobile navigation" className="h-[calc(100vh-72px)] overflow-y-auto bg-navy-900 px-6 py-8 xl:hidden" data-id="element-239" data-mp="15gx2n78yacf9">
            <ul className="space-y-1" data-id="element-240" data-mp="k23jb82p15ux">
              {navLinks.map((l, i) => <motion.li key={l.href} initial={{
            opacity: 0,
            x: -16
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.05 * i,
            duration: 0.3
          }} data-id="element-241" data-mp="f27ex7q33ceu" data-mpi={i}>
                  <a href={l.href} onClick={onNavClick} className="flex items-center justify-between border-b border-white/10 py-5 font-heading text-2xl font-bold uppercase tracking-tight text-white" data-id="element-242" data-mp="19rl8xj2oqql">
                    {l.label}
                    <ArrowRight className="h-5 w-5 text-brand-400" aria-hidden="true" data-id="element-243" data-mp="3dskhlvaiswvi" />
                  </a>
                </motion.li>)}
            </ul>

            <a href="#contact" onClick={onNavClick} className="mt-8 flex items-center justify-center gap-2 bg-brand-500 py-4 text-sm font-bold uppercase tracking-[0.14em] text-white" data-id="element-244" data-mp="3ipu698q354ia">
              Get a Free Estimate
              <ArrowRight className="h-4 w-4" aria-hidden="true" data-id="element-245" data-mp="ezacpra65bu" />
            </a>
            <a href={company.phoneHref} className="mt-3 flex items-center justify-center gap-2 border border-white/20 py-4 text-sm font-bold uppercase tracking-[0.14em] text-white" data-id="element-246" data-mp="5bz6a7uf1rp8">
              <Phone className="h-4 w-4 text-brand-400" aria-hidden="true" data-id="element-247" data-mp="3rr1z3b9u1d4z" />
              {company.phone}
            </a>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}